import { render, staticRenderFns } from "./LastYearComparisonConsumption.vue?vue&type=template&id=09909484&scoped=true&lang=pug&"
import script from "./LastYearComparisonConsumption.vue?vue&type=script&lang=ts&"
export * from "./LastYearComparisonConsumption.vue?vue&type=script&lang=ts&"
import style0 from "./LastYearComparisonConsumption.vue?vue&type=style&index=0&id=09909484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09909484",
  null
  
)

export default component.exports